import { StateCreator } from 'zustand';
import { PersistStorage, devtools, persist } from 'zustand/middleware';
import loggerMiddleware from './logger-middleware';

const getStorageNameWithPrefix = (name: string) => 'health-individual:' + name;

type Options = {
	name: string;
	devtoolsEnabled: boolean;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	storage: PersistStorage<any> | undefined;
};

const sharedMiddlewares = <T = unknown>(f: StateCreator<T>, options: Options) =>
	devtools(
		loggerMiddleware(
			persist(f, {
				name: getStorageNameWithPrefix(options.name),
				storage: options.storage,
			}),
			getStorageNameWithPrefix(options.name)
		),
		{ enabled: options.devtoolsEnabled, name: options.name }
	);

export default sharedMiddlewares;
